export { default } from './DisplayHeading';



// WEBPACK FOOTER //
// ./app/components/shared/UGC/DisplayHeading/index.js